// removed by extract-text-webpack-plugin
module.exports = {"logo-bg":"logo-bg_2_MNQ","about":"about_1tCMG"};


//////////////////
// WEBPACK FOOTER
// ./components/about/style.less
// module id = 21
// module chunks = 0